export default __webpack_public_path__ + "static/digital-transformation-student-onboarding-89f3ee1e5904d36fcd0a95fee5e8d944.jpg";